import { joinUrl } from '@root/src/web/lib/joinUrl';
export const getDiscussion = async (ajaxUrl, shortUrl) => {
    const url = joinUrl([ajaxUrl, 'discussion', shortUrl]);
    return fetch(url)
        .then((response) => {
        if (!response.ok) {
            throw Error(response.statusText ||
                `getDiscussion | An api call returned HTTP status ${response.status}`);
        }
        return response;
    })
        .then((response) => response.json())
        .then((json) => json)
        .catch((error) => {
        window.guardian.modules.sentry.reportError(error, 'get-discussion');
    });
};
